var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscendMulticolorBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 96,
    viewBox: "0 0 1152 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13791_236217)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 96,
    rx: 4,
    fill: "#994878",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 188.719,
    cy: 29.9321,
    r: 13.7192,
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 877.719,
    cy: 37.9321,
    r: 13.7192,
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M267.757 129.854C271.573 129.854 275.337 128.977 278.759 127.289C282.181 125.601 285.169 123.149 287.492 120.122C289.815 117.095 291.41 113.574 292.155 109.832C292.899 106.089 292.773 102.226 291.785 98.5402C290.798 94.8545 288.975 91.4455 286.46 88.5767C283.944 85.7079 280.802 83.4564 277.276 81.9962C273.751 80.536 269.937 79.9063 266.13 80.1559C262.322 80.4054 258.623 81.5275 255.319 83.4354L259.05 89.8983C261.363 88.5628 263.953 87.7774 266.618 87.6027C269.283 87.428 271.953 87.8688 274.421 88.8909C276.888 89.913 279.088 91.4891 280.849 93.4973C282.61 95.5054 283.885 97.8917 284.577 100.472C285.268 103.052 285.357 105.756 284.835 108.376C284.314 110.995 283.198 113.46 281.572 115.579C279.946 117.698 277.854 119.415 275.459 120.596C273.063 121.777 270.428 122.392 267.757 122.392L267.757 129.854Z",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M592.875 -14.8109C586.912 -12.5058 581.559 -8.85992 577.23 -4.15519C572.902 0.549528 569.714 6.18695 567.912 12.321C566.111 18.455 565.745 24.9211 566.842 31.2193C567.94 37.5174 570.471 43.4786 574.241 48.6419L584.34 41.2687C581.701 37.6544 579.929 33.4815 579.16 29.0728C578.392 24.6641 578.648 20.1378 579.909 15.844C581.17 11.5502 583.402 7.60402 586.432 4.31071C589.462 1.0174 593.209 -1.53473 597.383 -3.14828L592.875 -14.8109Z",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M440.352 -2.2208L454.679 13.6961L433.731 18.145L440.352 -2.2208Z",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M532.495 104.188L533.646 66.8654L565.393 86.5236L532.495 104.188Z",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 270.117,
    y: -14.1055,
    width: 22.4966,
    height: 22.4966,
    transform: "rotate(40.2955 270.117 -14.1055)",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M770.219 13.0754L696.691 87.7372C696.691 87.7372 696.358 87.9061 696.191 87.7372L670.24 61.386C670.24 61.386 669.907 61.2171 669.741 61.386L592.968 139.342C590.889 141.453 592.386 145 595.297 145H892.74C895.651 145 897.065 141.453 895.068 139.342L770.718 13.0754C770.718 13.0754 770.386 12.9065 770.219 13.0754Z",
    fill: "#994878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13791_236217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 96,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendMulticolorBackground);
export default __webpack_public_path__ + "static/media/AscendMulticolorBackground.48965a7a708a5d1c2d0ee6d32a8f684f.svg";
export { ForwardRef as ReactComponent };